// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceDropletSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 15.877C18 19.258 15.314 22 12 22s-6-2.741-6-6.123c0-4.293 4.246-11.474 5.594-13.646a.472.472 0 0 1 .812 0C13.754 4.403 18 11.584 18 15.877z"
    />
  </svg>
);
export default SvgScienceDropletSolid;
